import notificationStore from '../notificationStore';

export interface Notification {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
  warning: (message: string) => void;
}

export default function useNotifications() {
  return {
    success: notificationStore.success.bind(notificationStore),
    error: notificationStore.error.bind(notificationStore),
    info: notificationStore.info.bind(notificationStore),
    warning: notificationStore.warning.bind(notificationStore),
  };
}
